module.exports = __webpack_public_path__ + "static/media/quizBadgeLevel5Locked.29eab592.png";